module.exports = __webpack_public_path__ + "img/chanpin_4@2x.55bed2a2.png";